<template>
  <div class="message_left">
    <div
      :class="['message_item', activeItem == index ? ' activeItem' : '']"
      v-for="(item, index) in messageList"
      :key="index"
      @click="onClickItem(index)"
    >
      <img :src="item.url" alt="" />
      <div class="info_right">
        <div class="news" v-if="item.news"></div>
        <p>{{ $t("lang." + item.title) }}</p>
        <p>{{ item.msgValue }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  components: {},
  inject: ["messageRecordPro"],
  data() {
    return {
      activeItem: 0,
      messageList: [
        {
          url: require("@/assets/img/device_list/equipment.png"),
          title: "设备消息",
          msgValue: this.$t("lang.暂无消息"),
          news: false,
        },
        {
          url: require("@/assets/img/device_list/report.png"),
          title: "告警消息",
          msgValue: "--",
          news: false,
        },
        {
          url: require("@/assets/img/device_list/account.png"),
          title: "账号消息",
          msgValue: this.$t("lang.暂无消息"),
          news: true,
        },
        {
          url: require("@/assets/img/device_list/announcement.png"),
          title: "公告消息",
          msgValue: this.$t("lang.暂无消息"),
          news: true,
        },
      ],
    };
  },
  created() {
    this.getDeviceMessageOne();
    this.getAccountMessageOne();
    this.getAdvertisementMessage();
  },
  methods: {
    ...mapActions({
      deviceMessageOne: "ZD_DeviceMessageOne",
      accountMessageOne: "ZD_AccountMessageOne",
      advertisementMessage: "ZD_AdvertisementMessage",
    }),
    onClickItem(index) {
      if (index == 1) return;
      this.activeItem = index;
      this.messageRecordPro.$refs.messageListRightRef.activeItem = index;
      localStorage.setItem(`news${index}`, new Date().getTime());
      this.messageList[index].news = false;
    },
    async getDeviceMessageOne() {
      let res = await this.deviceMessageOne({});
      if (res.success !== 1) return;
      if (this.emptyJudgment(res.deviceMsg)) return;
      this.messageList[0].msgValue =
        res.deviceMsg.msgValue || this.$t("lang.暂无消息");
    },
    async getAccountMessageOne() {
      let res = await this.accountMessageOne({});
      if (res.success !== 1) return;
      if (this.emptyJudgment(res.accountMsg)) {
        this.messageList[2].news = false;
        return;
      }
      this.messageList[2].msgValue =
        res.accountMsg.msgValue || this.$t("lang.暂无消息");
      let current = localStorage.getItem("news2");
      if (Number(current) > new Date(res.accountMsg.msgTime).getTime()) {
        this.messageList[2].news = false;
      }
    },
    async getAdvertisementMessage() {
      let res = await this.advertisementMessage({
        systemid: 21,
        vendingtype: 1,
        lan: this.$i18n.locale == "zh-CN" ? "zh" : "en",
      });
      if (res.success !== 1) return;
      if (this.emptyJudgment(res.value.title))
        return (this.messageList[3].news = false);
      this.messageList[3].msgValue =
        res.value.title.replace(/\\n/g, "") || this.$t("lang.暂无消息");
      let current = localStorage.getItem("news3");
      if (Number(current) > new Date(res.value.updateTime).getTime()) {
        this.messageList[3].news = false;
      }
    },
    emptyJudgment(val) {
      if (val == "" || val == null || val == undefined || val.length < 1) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script> 

<style scoped lang='less'>
.message_left {
  width: 369px;
  border: 1px solid #cccccc;
  margin-right: 20px;
  padding-top: 20px;
}
.message_item {
  padding: 22px 43px 22px 17px;
  cursor: pointer;
  display: flex;
  position: relative;
  img {
    width: 37px;
    height: 37px;
    margin-right: 15px;
  }
  .info_right {
    p:first-child {
      font-size: 14px;
      color: #333;
    }
    p:last-child {
      font-size: 14px;
      color: #999;
      width: 190px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .news {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: red;
      position: absolute;
      right: 20px;
      top: 20px;
    }
  }
}
.message_item:hover {
  background-color: #f6f6f6;
}
.activeItem {
  background-color: #f6f6f6;
}
</style>